__turbopack_context__.v({
  "arm": "not-found-module__sxuMuG__arm",
  "back": "not-found-module__sxuMuG__back",
  "context": "not-found-module__sxuMuG__context",
  "element": "not-found-module__sxuMuG__element",
  "face": "not-found-module__sxuMuG__face",
  "left-arm": "not-found-module__sxuMuG__left-arm",
  "mouth": "not-found-module__sxuMuG__mouth",
  "not-found": "not-found-module__sxuMuG__not-found",
  "right-arm": "not-found-module__sxuMuG__right-arm",
  "tipsiz-body": "not-found-module__sxuMuG__tipsiz-body",
  "tipsize": "not-found-module__sxuMuG__tipsize",
  "upper-face": "not-found-module__sxuMuG__upper-face",
  "wrapper": "not-found-module__sxuMuG__wrapper",
});
